import * as userRequest from "@/utils/userRequest";

interface QueryParams {
  startDate: string;
  endDate: string;
  timezone: string;
}

export default async function getPortfolioService(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any,
  queryParams?: QueryParams
) {
  try {
    const res = await userRequest.post(
      "portfolio/statistic",
      {
        params: queryParams?.startDate && queryParams?.endDate && queryParams,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("🚀 ~ getPortfolioService ~ res:", res);
    if (true || res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getPortfolioService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
